import { FC } from "react";
import {
  Avatar,
  Card,
  CardContent,
  CardHeader,
  SxProps,
  ToggleButton,
  ToggleButtonGroup,
  useMediaQuery,
} from "@mui/material";
import { useSelectedChallengeContext } from "@context/SelectedChallengeContext";
import { Cancel, ThumbDown, ThumbUp } from "@mui/icons-material";
import { Challenge } from "@/models/pdfData";
import { useGameDataContext } from "@context/GameDataContext";

const ChallengeResultSelector: FC = () => {
  const {
    challenge: { challengeResult, team },
    setChallengeResult,
  } = useSelectedChallengeContext();
  const { game } = useGameDataContext();

  const teams = { team1: game?.gameData.team1, team2: game?.gameData.team2 };

  const challengingTeam: Challenge["team"] =
    (team === "ref" ? "team1" : team) || "team1";
  const otherTeam: Challenge["team"] =
    team === "ref" ? "team2" : team === "team2" ? "team1" : "team2";
  const isRefereeChallenge = team === "ref";

  const toggleButtonSx: SxProps = {
    display: "flex",
    gap: 1,
  };
  const orientation = useMediaQuery("(min-width:1200px)")
    ? "horizontal"
    : "vertical";

  const SuccessfulToggleButton = () => (
    <ToggleButton value={challengingTeam} sx={toggleButtonSx}>
      <ThumbUp />
      Erfolgreich
    </ToggleButton>
  );

  const UnsuccessfulToggleButton = () => (
    <ToggleButton value={otherTeam} sx={toggleButtonSx}>
      <ThumbDown />
      Nicht erfolgreich
    </ToggleButton>
  );

  const Team1ToggleButton = () => (
    <ToggleButton value={challengingTeam} sx={toggleButtonSx}>
      <Avatar src={teams[challengingTeam]?.iconUrl} />
      {teams[challengingTeam]?.shortName}
    </ToggleButton>
  );

  const Team2ToggleButton = () => (
    <ToggleButton value={otherTeam} sx={toggleButtonSx}>
      <Avatar src={teams[otherTeam]?.iconUrl} />
      {teams[otherTeam]?.shortName}
    </ToggleButton>
  );

  return (
    <Card
      variant="elevation"
      elevation={5}
      sx={{ width: orientation === "vertical" ? "350px" : "800px", mx: 2 }}
    >
      <CardHeader
        title={"Ergebnis"}
        titleTypographyProps={{ variant: "subtitle1", align: "center" }}
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ justifyContent: "center", display: "flex" }}>
        <ToggleButtonGroup
          orientation={orientation}
          color="primary"
          value={challengeResult}
          exclusive
          onChange={(event, value) => {
            setChallengeResult(value);
          }}
          sx={{ px: 2 }}
        >
          {isRefereeChallenge ? (
            <Team1ToggleButton />
          ) : (
            <SuccessfulToggleButton />
          )}
          {isRefereeChallenge ? (
            <Team2ToggleButton />
          ) : (
            <UnsuccessfulToggleButton />
          )}
          <ToggleButton value={"unresolvable"} sx={toggleButtonSx}>
            <Cancel />
            Nicht auflösbar
          </ToggleButton>
        </ToggleButtonGroup>
      </CardContent>
    </Card>
  );
};

export default ChallengeResultSelector;
